import { render } from "./StartPanel.vue?vue&type=template&id=387d0f16&scoped=true"
import script from "./StartPanel.vue?vue&type=script&lang=js"
export * from "./StartPanel.vue?vue&type=script&lang=js"

import "./StartPanel.vue?vue&type=style&index=0&id=387d0f16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387d0f16"]])

export default __exports__